import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import Vue from 'vue';
import { format as Format, parse as Parse, add as Add, sub as Sub, addMinutes, subMinutes, startOfDay, startOfWeek, startOfMonth, startOfYear, startOfQuarter, getTime, isBefore as _isBefore, differenceInMinutes } from 'date-fns';
import { enGB, enUS, es, fr, ja } from 'date-fns/locale';
import { TimeFormat } from '../api';
export var plugin = {
  parse: function parse(date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyyMMdd';
    return Parse(date, format, new Date());
  },
  convert: function convert(date, inputFormat, outputFormat) {
    var parsed = this.parse(date, inputFormat);
    return this.format(parsed, outputFormat);
  },
  utc: function utc(date) {
    if (date) {
      return addMinutes(date, date.getTimezoneOffset());
    } else {
      return null;
    }
  },
  timezone: function timezone(date) {
    if (date) {
      return subMinutes(date, date.getTimezoneOffset());
    } else {
      return null;
    }
  },
  local: function local(date) {
    var _Vue$prototype, _Vue$prototype$authPl, _Vue$prototype$authPl2, _Vue$prototype$authPl3;
    var offset = (Vue === null || Vue === void 0 ? void 0 : (_Vue$prototype = Vue.prototype) === null || _Vue$prototype === void 0 ? void 0 : (_Vue$prototype$authPl = _Vue$prototype.authPlugin) === null || _Vue$prototype$authPl === void 0 ? void 0 : (_Vue$prototype$authPl2 = _Vue$prototype$authPl.info) === null || _Vue$prototype$authPl2 === void 0 ? void 0 : (_Vue$prototype$authPl3 = _Vue$prototype$authPl2.location) === null || _Vue$prototype$authPl3 === void 0 ? void 0 : _Vue$prototype$authPl3.timeZoneOffset) || 0;
    var utc = new Date(new Date(date).toUTCString().slice(0, -4));
    var local = this.add(utc, {
      seconds: offset
    });
    return local;
  },
  iso: function iso(date) {
    // from iso string
    return new Date(date);
  },
  timestamp: function timestamp(date) {
    return Math.floor(getTime(date) / 1000);
  },
  now: function now() {
    return Date.now();
  },
  add: function add(date, duration, inputFormat, outputFormat) {
    if (inputFormat) {
      date = this.parse(date, inputFormat);
    }
    date = Add(date, duration);
    if (outputFormat) {
      date = this.format(date, outputFormat);
    }
    return date;
  },
  sub: function sub(date, duration, inputFormat, outputFormat) {
    if (inputFormat) {
      date = this.parse(date, inputFormat);
    }
    date = Sub(date, duration);
    if (outputFormat) {
      date = this.format(date, outputFormat);
    }
    return date;
  },
  minutes: function minutes(total) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.presets.time;
    var hours = Math.floor(total / 60);
    var minutes = total % 60;
    var date = new Date(null, null, null, hours, minutes);
    if (format) {
      return this.format(date, format);
    }
    return date;
  },
  getMinutes: function getMinutes(val) {
    var date = startOfDay(val);
    var time = differenceInMinutes(val, date);
    return time;
  },
  getStartOfDayUTC: function getStartOfDayUTC(val) {
    if (val) {
      var utc = startOfDay(val);
      var date = Sub(utc, {
        minutes: utc.getTimezoneOffset()
      });
      return date;
    } else {
      return null;
    }
  },
  isBefore: function isBefore(a, b) {
    return _isBefore(a, b);
  },
  startOf: function startOf(date, unit) {
    if (['day', 'days'].includes(unit)) {
      return startOfDay(date);
    }
    if (['week', 'weeks'].includes(unit)) {
      return startOfWeek(date);
    }
    if (['month', 'months'].includes(unit)) {
      return startOfMonth(date);
    }
    if (['quarter', 'quarters'].includes(unit)) {
      return startOfQuarter(date);
    }
    if (['year', 'years'].includes(unit)) {
      return startOfYear(date);
    }
  },
  presets: {
    get time() {
      var _Vue$prototype2, _Vue$prototype2$authP, _Vue$prototype2$authP2, _Vue$prototype2$authP3;
      var format = Vue === null || Vue === void 0 ? void 0 : (_Vue$prototype2 = Vue.prototype) === null || _Vue$prototype2 === void 0 ? void 0 : (_Vue$prototype2$authP = _Vue$prototype2.authPlugin) === null || _Vue$prototype2$authP === void 0 ? void 0 : (_Vue$prototype2$authP2 = _Vue$prototype2$authP.info) === null || _Vue$prototype2$authP2 === void 0 ? void 0 : (_Vue$prototype2$authP3 = _Vue$prototype2$authP2.location) === null || _Vue$prototype2$authP3 === void 0 ? void 0 : _Vue$prototype2$authP3.timeFormat;
      if (format && format === TimeFormat['24']) {
        return 'HH:mm';
      }
      return 'h:mm a';
    },
    get full() {
      return "EEEE, MMMM do yyyy ".concat(this.time);
    },
    get compact() {
      return "EEE, do MMM yy ".concat(this.time);
    },
    long: 'EEEE, MMMM do yyyy',
    short: 'dd/MM/yyyy'
  }
};
export default (function (context, inject) {
  var format = function format(date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyyMMdd';
    if (date) {
      var localeMapping = {
        en: enGB,
        'en-US': enUS,
        es: es,
        fr: fr,
        ja: ja
      };
      var localeCode = context.app.i18n.locale;
      var locale = localeMapping[localeCode] || enUS;
      return Format(date, format, {
        locale: locale
      });
    } else {
      return null;
    }
  };
  var getOrdinal = function getOrdinal(day) {
    var locale = context.app.i18n.locale;
    var ordinal_rules = new Intl.PluralRules(locale, {
      type: 'ordinal'
    });
    var category = ordinal_rules.select(day);
    var dayLabel = window.$nuxt.$t('datetime.ordinals.' + category, {
      number: day
    });
    return dayLabel;
  };
  Object.assign(plugin, {
    format: format,
    getOrdinal: getOrdinal
  });
  inject('date', plugin);
});